import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchCountry } from "../../../features/country/countrySlice";
import { useSelector } from "react-redux";

function ItemDescription({ item }) {
  const dispatch = useDispatch();
  const [country, setCountry] = useState(null);
  const [countryLogisticAddress, setCountryLogisticAddress] = useState(null);
  const { t, i18n } = useTranslation();
  const authUser = useSelector((state) => state.auth);
  const isAdmin = authUser?.user?.roles.includes("ROLE_ADMIN");

  useEffect(() => {
    dispatch(fetchCountry(item.country)).then((response) => {
      setCountry(response.payload);
    });

    dispatch(fetchCountry(item.logisticAddress?.country)).then((response) => {
      setCountryLogisticAddress(response.payload);
    });
    if (item.comment) {
      item.comment.split("\n\n").map(renderParagraph);
    }
  }, []);

  function renderParagraph(paragraph) {
    if (paragraph) {
      const [firstLine, ...rest] = paragraph?.split("\n");

      return (
        <p>
          {firstLine}
          {rest.map((line, k) => (
            <span key={k}>
              <br />
              {line}
            </span>
          ))}
        </p>
      );
    }
  }

  return (
    <>
      <div className="grid grid-cols-2 mt-6 w-full">
        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100">
          <div className="col-span-6 font-bold">{t("items.category")} :</div>
          <div className="col-span-6">{item.itemCategory.name}</div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 xl:bg-gray-100">
          <div className="col-span-6 font-bold">{t("items.subCategory")} :</div>
          <div className="col-span-6">
            {item.itemSubCategory?.name || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100 xl:bg-white">
          <div className="col-span-6 font-bold">{t("items.country")} :</div>
          <div className="col-span-6">
            {country?.labelFr || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2">
          <div className="col-span-6 font-bold">{t("items.batchNumber")} :</div>
          <div className="col-span-6">
            {item.batchNumber || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100">
          <div className="col-span-6 font-bold">{t("items.unCode")} :</div>
          <div className="col-span-6">
            {item.unCode || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 xl:bg-gray-100">
          <div className="col-span-6 font-bold">{t("items.hsCode")} :</div>
          <div className="col-span-6">
            {item.hsCode || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100 xl:bg-white">
          <div className="col-span-6 font-bold">{t("items.class")} :</div>
          <div className="col-span-6">
            {item.class || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2">
          <div className="col-span-6 font-bold">
            {t("items.themalConditions")} :
          </div>
          <div className="col-span-6">
            {item.thermalConditions || t("items.notAvailable")}
          </div>
        </div>

        <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100">
          <div className="col-span-6 font-bold">{t("items.useByDate")} :</div>
          <div className="col-span-6">
            {item.useByDate
              ? dayjs(item.useByDate).format("DD/MM/YYYY")
              : t("items.notAvailable")}
          </div>
        </div>

        {(isAdmin || item.partner["@id"] === authUser?.user?.partner) && (
          <>
            <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 xl:bg-gray-100">
              <div className="col-span-6 font-bold">{t("items.partner")} :</div>
              <div className="col-span-6">
                {item.partner?.name || t("items.notAvailable")}
              </div>
            </div>

            <div className="col-span-2 xl:col-span-1 grid grid-cols-12 px-3 py-2 bg-gray-100 xl:bg-white">
              <div className="col-span-6 font-bold">
                {t("items.partnerLogisticAddress")} :
              </div>
              <div className="col-span-6">
                {item.logisticAddress?.address || t("items.notAvailable")}
                <br />
                {item.logisticAddress?.zipcode} {item.logisticAddress?.city}
                <br />
                {i18n.language === "fr"
                  ? countryLogisticAddress?.labelFr
                  : countryLogisticAddress?.labelEn}
              </div>
            </div>

            <div className="col-span-2 grid grid-cols-12 py-2 xl:bg-gray-100">
              <div className="col-span-12 lg:col-span-6 xl:col-span-3 pl-3 font-bold">
                {t("items.comment")} :
              </div>
              <div className="col-span-12 lg:col-span-6 mt-2 ml-3 lg:mt-0 lg:ml-0 xl:col-span-9">
                {(item?.comment && renderParagraph(item.comment)) ||
                  t("items.notAvailable")}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ItemDescription;
